import React from 'react'
import {Box,TextInput, Form, FormField,Select} from 'grommet'
import {Cube,ThreeD,Currency,Notes,DocumentUpload} from 'grommet-icons';
import {RequestButton} from './utils/shared/shipmentViewFunctions'

function DefaultPiece(props){
    const lab = props.props.lab
    const labs = props.props.labs
    return (
        <Box direction='row' flex="grow" margin={{top: 'large'}}>
            <FormField required label='Default Weight' name='weight' margin='small' > <TextInput name='weight' icon={<Cube />} placeholder="Enter Weight" /> </FormField>
            <FormField required label='Length' name='length'  margin='small' > <TextInput name='length' icon={<ThreeD />}  placeholder="Enter Length" /> </FormField>
            <FormField required label='Width' name='width'  margin='small' > <TextInput name='width' icon={<ThreeD />} placeholder="Enter Width" /> </FormField>
            <FormField required label='Height' name='height' margin='small' > <TextInput name='height'icon={<ThreeD />}  placeholder="Enter Height" /> </FormField>
            <FormField required label='Customs Value' name='customs_value' margin='small' > <TextInput name='customs_value' icon={<Currency />} placeholder="Enter Customs Value" /> </FormField>
            <FormField label='Commodity Owner' name='lab' margin='small' ><Select name='lab' placeholder={'Select Owner'} onChange={props.props.setOwner} options={labs} value={lab} labelKey="name" valueKey="id" onSearch={text => { const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'); const exp = new RegExp(escapedText, 'i'); props.props.setLabs(labs.filter(o => exp.test(o.name))); }} /> </FormField>
        </Box>
    )
}

function CreateCommodityForm (props) {
  return ( 
    <Form value={props.value} onSubmit={props.handleSubmit} onChange={nextValue => props.handleChange(nextValue)}>
    <Box direction='row' flex="grow" margin={{top: 'small'}}>
        <FormField required label='Commodity Display Name' name='display_name' margin='small' > <TextInput icon={<Notes />} name='display_name' placeholder="Enter Commodity Display Name" /> </FormField>
        <FormField required label='Commodity Name' name='name' margin='small' > <TextInput  icon={<Notes />}name='name' placeholder="Enter Commodity Name" /> </FormField>
        <FormField required label='Commodity Description' name='description' margin='small' > <TextInput  icon={<Notes />}name='description' placeholder="Enter Commodity Description" /> </FormField>
        <FormField required label='Commodity Code' name='code' margin='small' > <TextInput name='code'icon={<Notes />} placeholder="Enter Commodity Code" /> </FormField>
    </Box>
    <DefaultPiece props={props} />
     <Box>
        <FormField label='Documents (MSDS)' margin='small' > <TextInput icon={<DocumentUpload/>}type="file" onChange={props.handleDocsChange} /> </FormField>
    </Box>
    <Box direction='row' justify="center" margin={{top: 'medium',bottom:'medium'}}> <RequestButton load={props.load} label={"Create Commodity"} /> </Box>
   </Form>

  )
}

export default CreateCommodityForm
